import request from '@/services/api';

// 文件上传
export function filesUpload(data: FormData) {
  return request({
    url: '/tiguUpload/uploads',
    method: 'post',
    data,
    timeout: 120000,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
}